export default [
  { key: 'energy', unit: 'kJ', daily_reference_intake: 8400, is_optional: false },
  { key: null, unit: 'kcal', daily_reference_intake: 2000, is_optional: false },
  { key: 'fat', unit: 'g', daily_reference_intake: 70, is_optional: false },
  { key: 'saturated_fat', unit: 'g', daily_reference_intake: 20, is_optional: false },
  { key: 'monounsaturated_fat', unit: 'g', daily_reference_intake: null, is_optional: false },
  { key: 'polyunsaturated_fat', unit: 'g', daily_reference_intake: null, is_optional: false },
  { key: 'carbohydrate', unit: 'g', daily_reference_intake: 260, is_optional: false },
  { key: 'sugar', unit: 'g', daily_reference_intake: 90, is_optional: false },
  { key: 'polyols', unit: 'g', daily_reference_intake: null, is_optional: false },
  { key: 'starch', unit: 'g', daily_reference_intake: null, is_optional: false },
  { key: 'fibre', unit: 'g', daily_reference_intake: null, is_optional: false },
  { key: 'protein', unit: 'g', daily_reference_intake: 50, is_optional: false },
  { key: 'salt', unit: 'g', daily_reference_intake: 6, is_optional: false },

  // Optional nutrients
  { key: 'biotin', unit: 'μg', daily_reference_intake: 50, is_optional: true },
  { key: 'calcium', unit: 'mg', daily_reference_intake: 800, is_optional: true },
  { key: 'chloride', unit: 'mg', daily_reference_intake: 800, is_optional: true },
  { key: 'chromium', unit: 'μg', daily_reference_intake: 40, is_optional: true },
  { key: 'copper', unit: 'mg', daily_reference_intake: 1, is_optional: true },
  { key: 'fluoride', unit: 'mg', daily_reference_intake: 3.5, is_optional: true },
  { key: 'folic_acid', unit: 'μg', daily_reference_intake: 200, is_optional: true },
  { key: 'iodine', unit: 'μg', daily_reference_intake: 150, is_optional: true },
  { key: 'iron', unit: 'mg', daily_reference_intake: 14, is_optional: true },
  { key: 'magnesium', unit: 'mg', daily_reference_intake: 375, is_optional: true },
  { key: 'manganese', unit: 'mg', daily_reference_intake: 2, is_optional: true },
  { key: 'molybdenum', unit: 'μg', daily_reference_intake: 50, is_optional: true },
  { key: 'niacin', unit: 'mg', daily_reference_intake: 16, is_optional: true },
  { key: 'pantothenic_acid', unit: 'mg', daily_reference_intake: 6, is_optional: true },
  { key: 'phosphorus', unit: 'mg', daily_reference_intake: 700, is_optional: true },
  { key: 'potassium', unit: 'mg', daily_reference_intake: 2000, is_optional: true },
  { key: 'riboflavin', unit: 'mg', daily_reference_intake: 1.4, is_optional: true },
  { key: 'selenium', unit: 'μg', daily_reference_intake: 55, is_optional: true },
  { key: 'thiamin', unit: 'mg', daily_reference_intake: 1.1, is_optional: true },
  { key: 'vitamin_a', unit: 'μg', daily_reference_intake: 800, is_optional: true },
  { key: 'vitamin_b12', unit: 'μg', daily_reference_intake: 2.5, is_optional: true },
  { key: 'vitamin_b6', unit: 'mg', daily_reference_intake: 1.4, is_optional: true },
  { key: 'vitamin_c', unit: 'mg', daily_reference_intake: 80, is_optional: true },
  { key: 'vitamin_d', unit: 'μg', daily_reference_intake: 5, is_optional: true },
  { key: 'vitamin_e', unit: 'mg', daily_reference_intake: 12, is_optional: true },
  { key: 'vitamin_k', unit: 'μg', daily_reference_intake: 75, is_optional: true },
  { key: 'zinc', unit: 'mg', daily_reference_intake: 10, is_optional: true }
]
